import QuantitySelector from './QuantitySelector';

export default QuantitySelector;
